module.exports = __webpack_public_path__ + "media/assets/images/ControlPV-logo-login-18aca101593427da8a102b938c706459.svg";